import React from 'react';
import 'pixi-spine';
import { createRoot } from 'react-dom/client'; // Import createRoot
import { BrowserRouter } from 'react-router-dom';
import App from './App';
import { init } from './core/helpers/init';

const worker = new Worker(`${process.env.PUBLIC_URL}/events.worker.js`);
init();

createRoot(document.getElementById('root')).render(
  // <React.StrictMode>
  <BrowserRouter>
    <App />
  </BrowserRouter>
  // </React.StrictMode>
);

export { worker };
